import { DesigntimeComponent } from './DesigntimeComponent.js'
import { LiquidString } from '../common/LiquidString.js'
import * as $ from 'jquery';

class AngularRedirect extends DesigntimeComponent {
    static staticName = "Redirect in angular";
    static staticId = "angularRedirect";
    hasRuntimeView = true;

    constructor(identifyer) {
        super(identifyer, 1);

        this.hasNextButton = false;

        this.values = {
            header: new LiquidString("Redirecting...", `${this.id}_header`),
            text: new LiquidString("", `${this.id}_text`),
            buttontext: { value: "" },
            imageurl: { value: "", dontTranslate: true },
            imageclass: { value: "", dontTranslate: true },
            url: { value: "/dashboard" }
        };
    }

    getRuntimeView(context) {
        let $view = $("<div></div>");
        if (this.values.imageurl.value) {
            var $imagebox = $("<div class='sid-question-image'></div>");
            $imagebox.append($("<img class='" + this.values.imageclass.value + "' src='" + context.getContentUrl() + this.values.imageurl.value + "'>"));
            $view.append($imagebox);
        }
        var textbox = $("<div class='sid-question-text'></div>");

        textbox.append(this.values.header.getTag("h3"));
        textbox.append(this.values.text.getTag("p"));
        $view.append(textbox);


        if (false) {
            this.eventBroker.fire("nexButtonClickedEvent", this.nodeId);
        }

        return $view;
    }

    onNodeShown(nodeId) {
        let redirectParams = { url: this.values.url.value, type: "internal" };
        this.eventBroker.fire("redirectEvent", redirectParams)
    }
}

export { AngularRedirect }
